import { Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import { Logo } from "@/components/brand";

import { AppShell, NavGroup, NavItem } from "@/components/ui";

import "../admin.css";

const SECTIONS = [
  { id: "accounts", label: "Accounts", to: "/admin" },
  { id: "grants", label: "Grants", to: "/admin/grants" },
  { id: "roles", label: "Roles", to: "/admin/roles" },
] as const;

type AdminPath = (typeof SECTIONS)[number]["to"] | "/console/home";

/** The frame every platform screen renders inside. Staff, and nobody else. */
export function AdminShell() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  const go = (to: AdminPath) => (event: { preventDefault: () => void }) => {
    event.preventDefault();
    void navigate({ to });
  };

  const nav = (
    <NavGroup label="Platform">
      {SECTIONS.map((section) => (
        <NavItem
          key={section.id}
          href={section.to}
          active={section.to === "/admin" ? pathname === section.to : pathname.startsWith(section.to)}
          onClick={go(section.to)}
        >
          {section.label}
        </NavItem>
      ))}
    </NavGroup>
  );

  return (
    <AppShell
      railLabel="Platform"
      brand={<Logo size={22} />}
      nav={nav}
      railFooter={
        <NavItem href="/console/home" onClick={go("/console/home")}>
          Console
        </NavItem>
      }
    >
      <Outlet />
    </AppShell>
  );
}
